.sn-platform-requirements {
  display: flex;
  flex-direction: column;

  &__wrapper {
    background-color: var(--background-color-secondary, #f6f4f5);
    border-radius: var(--radius-size-lg, 12px);
    padding: map-get($spacings, xl);

    @include above($breakpoint-desktop) {
      padding: map-get($spacings, 2xl);
    }
  }

  &__left,
  &__right {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, md); // 16px — Figma gap between intro text and list (left), and between paragraphs (right)
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, md);
    list-style: none;
    margin: 0;
    padding: 0;
  }

  &__item {
    display: flex;
    align-items: flex-start;
    gap: map-get($spacings, xs);
    font-size: map-get($font-sizes, md);
    line-height: 24px;
    color: var(--text-color-primary);
  }

  &__check {
    flex-shrink: 0;
    color: #468beb; // TODO: no exact root token — Figma "Color Brand/Primary/Blue/dark"
  }

  .me-heading--4 {
    font-size: 28px;
    line-height: 36px;

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, 4xl); // 36px — Figma Heading/H5
      line-height: 48px;
    }
  }

  .me-text {
    // Figma Paragraph/Body 2 — Open Sans Regular 16px / 24px line-height (same on desktop and mobile)
    font-size: map-get($font-sizes, md); // 16px
    line-height: 24px;
  }
}
